// extracted by mini-css-extract-plugin
export default {"descriptionPhotoContainer":"descriptionPhoto_descriptionPhotoContainer__9F7ic"};